import React, { useState, useEffect } from "react";
import { message, Spin } from "antd";

const VerticalBanner = (props) => {
  const config = "https://s3.amazonaws.com/www.nocapvote.com";
  const [verticalBannerUp, setVerticalBannerUp] = useState(null);
  const [verticalBannerDown, setVerticalBannerDown] = useState(null);
  const [error, setError] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchAds = async () => {
      try {
        setLoading(true);
        const up = await props.getAd(
          `vertical-banner-${props.position}-up`,
          props.page
        );
        setVerticalBannerUp(up);
        const down = await props.getAd(
          `vertical-banner-${props.position}-down`,
          props.page
        );
        setVerticalBannerDown(down);
        console.log(verticalBannerUp);
        console.log(verticalBannerDown);
      } catch (e) {
        setError(e);
        console.error("Error loading ads:", e);
      } finally {
        setLoading(false);
      }
    };

    fetchAds();
  }, [props.page, props.position]); // eslint-disable-line

  if (error) {
    // Silently fail - don't show error message for ads
    console.error("Ad loading error:", error);
    return null;
  }

  if (loading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center',
        minHeight: '200px'
      }}>
        <Spin />
      </div>
    );
  }

  return (
    <div 
      className="vertical-banner" 
      style={{
        position: 'sticky',
        top: '10px',
        alignSelf: 'flex-start'
      }}
    >
      {verticalBannerUp && (
        <div className="vertical-banner-container">
          <img alt="vertical banner" src={`${config}${verticalBannerUp}`} />
        </div>
      )}
      {verticalBannerDown && (
        <div className="vertical-banner-container">
          <img alt="vertical banner" src={`${config}${verticalBannerDown}`} />
        </div>
      )}
    </div>
  );
};

export default VerticalBanner;